import { render } from "./ExpiryModal.vue?vue&type=template&id=5b96ded7&scoped=true"
import script from "./ExpiryModal.vue?vue&type=script&lang=js"
export * from "./ExpiryModal.vue?vue&type=script&lang=js"

import "./ExpiryModal.vue?vue&type=style&index=0&id=5b96ded7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b96ded7"]])

export default __exports__